import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';

const NewList = ({ initialValue, onCancel, onSubmit, listOptions = [] }) => {
  const layout = [
    {
      name: 'listName',
      label: 'Name',
      required: true,
    },
    {
      name: 'isPublic',
      label: 'Public',
      control: 'checkbox',
    },
    {
      name: 'copyFrom',
      label: 'Copy From',
      noEmptyOption: true,
    },
  ];

  if (initialValue) {
    layout[0].data = initialValue.name;
    layout[1].data = initialValue.isPublic ? 'Y' : 'N';
    layout[2].hidden = true;
  } else {
    layout[2].options = [{ value: '0', label: 'Blank' }, ...listOptions];
  }

  return (
    <Form
      layout={[...layout]}
      exportFormat="object"
      submit={onSubmit}
      onCancel={onCancel}
      trackDirty={!!initialValue}
    />
  );
};

NewList.propTypes = {
  initialValue: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  listOptions: PropTypes.array,
};

export default NewList;
